import React, { useEffect, useState } from 'react';
import { api } from '../api';

import ShiftTag from '../components/ShiftTag';
import useBillFilter from '../components/useBillFilter';
const rowTime = (d) => { if (!d) return ''; const t = new Date(String(d).replace(' ', 'T') + (/Z$|[+-]\d\d:\d\d$/.test(String(d)) ? '' : 'Z')); return t.toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata', hour: 'numeric', minute: '2-digit', hour12: true }); };

const MODES = ['cash', 'upi', 'card'];
const money = (n) => `₹${Number(n || 0).toFixed(2)}`;

export default function BillHistoryPage() {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [bills, setBills] = useState([]);
  const { list: filteredBills, bar: billFilterBar } = useBillFilter(bills);
  const [expandedId, setExpandedId] = useState(null);
  const [expandedDetail, setExpandedDetail] = useState(null);
  const [payEdit, setPayEdit] = useState(null); // { mode, split: {cash, upi, card}, isSplit }
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const loadBills = () => {
    api.get(`/bills?date=${date}`).then((data) => setBills(data.bills)).catch(() => setBills([]));
    setExpandedId(null);
    setExpandedDetail(null);
    setPayEdit(null);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(loadBills, [date]);

  const loadDetail = async (id) => {
    try { setExpandedDetail(await api.get(`/bills/${id}`)); } catch (err) { setExpandedDetail(null); }
  };

  const toggleExpand = async (bill) => {
    setError(''); setPayEdit(null);
    if (expandedId === bill.id) { setExpandedId(null); setExpandedDetail(null); return; }
    setExpandedId(bill.id);
    setExpandedDetail(null);
    loadDetail(bill.id);
  };

  const formatTime = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(`${String(dateStr).replace(' ', 'T')}Z`);
    if (isNaN(d)) return dateStr;
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  const active = bills.filter((b) => b.status !== 'cancelled');
  const totalForDay = active.reduce((s, b) => s + b.total_amount, 0);
  const cancelledCount = bills.length - active.length;

  const run = async (fn) => {
    setError(''); setBusy(true);
    try { await fn(); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  const openPayEdit = (d) => {
    const split = { cash: '', upi: '', card: '' };
    (d.payments || []).forEach((p) => { split[p.mode] = String(p.amount); });
    setPayEdit({ mode: d.payment_mode || 'cash', isSplit: (d.payments || []).length > 1, split });
  };

  const savePayment = (d) => run(async () => {
    const body = payEdit.isSplit
      ? { payments: MODES.filter((m) => Number(payEdit.split[m]) > 0).map((m) => ({ mode: m, amount: Number(payEdit.split[m]) })) }
      : { payment_mode: payEdit.mode };
    await api.post(`/bills/${d.id}/payment`, body);
    setPayEdit(null);
    const keep = d.id;
    api.get(`/bills?date=${date}`).then((data) => setBills(data.bills)).catch(() => {});
    loadDetail(keep);
  });

  const editItems = (d) => {
    if (!window.confirm(`Edit ${d.bill_no}?\n\nIts items open in Billing. When you save there, ${d.bill_no} is cancelled (stock returned) and replaced by the new bill.`)) return;
    localStorage.setItem('icecream_edit_bill', JSON.stringify({
      id: d.id, bill_no: d.bill_no, payment_mode: d.payment_mode, discount: d.discount || 0,
      items: (d.items || []).map((i) => ({ product_id: i.product_id, name: i.product_name, quantity: i.quantity, is_free: !!i.is_free, combo_id: i.combo_id || null })),
    }));
    window.dispatchEvent(new CustomEvent('icecream-navigate', { detail: 'billing' }));
  };

  const deleteBill = (d) => {
    const reason = window.prompt(`Delete ${d.bill_no} permanently?\n${d.status !== 'cancelled' ? 'Its stock will be returned. ' : ''}This cannot be undone.\n\nType a reason:`);
    if (!reason || !reason.trim()) return;
    run(async () => {
      await api.post(`/bills/${d.id}/delete`, { reason: reason.trim() });
      loadBills();
    });
  };

  const btn = { height: 34, padding: '0 12px', borderRadius: 8, border: '1px solid #e2dcea', background: '#fff', fontWeight: 700, cursor: 'pointer', font: 'inherit', fontSize: 13 };

  return (
    <div>
      <div className="card">
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <h4 style={{ marginTop: 0 }}>Bill History</h4>
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        </div>
        <p style={{ fontSize: 13, color: 'var(--chocolate)', marginTop: -6 }}>
          {active.length} bills · ₹{totalForDay.toFixed(2)} total for this date{cancelledCount ? ` (${cancelledCount} cancelled, not counted)` : ''}. Click a bill to see details, change payment, edit or delete.
        </p>
        {error && <div style={{ padding: 10, borderRadius: 10, background: '#fdecef', color: '#d63d5b', fontWeight: 700, marginBottom: 10 }}>{error}</div>}

        {billFilterBar}
          <table>
          <thead><tr><th>Bill No</th><th>Items</th><th>Total</th><th>Payment</th><th>Status</th></tr></thead>
          <tbody>
            {filteredBills.map((b) => (
              <React.Fragment key={b.id}>
                <tr style={{ cursor: 'pointer', background: b.status === 'cancelled' ? '#FDF0F3' : expandedId === b.id ? '#F6F3FD' : 'transparent' }} onClick={() => toggleExpand(b)}>
                  <td>{b.day_no ? <><b>#{b.day_no}</b> <small style={{ color: '#8b84a0' }}>{b.bill_no}</small></> : b.bill_no}<ShiftTag billId={b.id} /><span style={{ display: 'inline-block', marginLeft: 8, fontSize: 12.5, color: '#6b6280', fontWeight: 600, whiteSpace: 'nowrap' }}>🕒 {rowTime(b.bill_date)}</span></td>
                  <td>{b.item_summary || '-'}</td>
                  <td style={{ textDecoration: b.status === 'cancelled' ? 'line-through' : 'none' }}>₹{b.total_amount.toFixed(2)}</td>
                  <td style={{ textTransform: 'capitalize' }}>{b.payment_mode}</td>
                  <td style={{ textTransform: 'capitalize', color: b.status === 'cancelled' ? 'var(--danger-dark)' : 'inherit', fontWeight: b.status === 'cancelled' ? 700 : 400 }}>
                    {b.status === 'cancelled' ? `Cancelled${b.cancel_reason ? ` — ${b.cancel_reason}` : ''}` : b.status}
                  </td>
                </tr>
                {expandedId === b.id && (
                  <tr>
                    <td colSpan={5} style={{ background: '#FAF9FD', padding: '12px 16px' }}>
                      {!expandedDetail ? (
                        <span>Loading...</span>
                      ) : (
                        <>
                          <div className="row" style={{ gap: 40, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                            <div>
                              <strong style={{ fontSize: 12.5 }}>Time</strong>
                              <div>{formatTime(expandedDetail.bill_date)}</div>
                            </div>
                            <div>
                              <strong style={{ fontSize: 12.5 }}>Items</strong>
                              {(expandedDetail.items || []).map((i) => (
                                <div key={i.id}>{i.product_name} × {i.quantity} — {i.is_free ? 'FREE' : money(i.price)}</div>
                              ))}
                            </div>
                            <div>
                              <strong style={{ fontSize: 12.5 }}>Payment Breakdown</strong>
                              {expandedDetail.payments && expandedDetail.payments.length > 0 ? (
                                expandedDetail.payments.map((p, i) => <div key={i} style={{ textTransform: 'capitalize' }}>{p.mode}: {money(p.amount)}</div>)
                              ) : (
                                <div style={{ textTransform: 'capitalize' }}>{expandedDetail.payment_mode}: {money(expandedDetail.total_amount)}</div>
                              )}
                            </div>
                            {expandedDetail.returns && expandedDetail.returns.length > 0 && (
                              <div>
                                <strong style={{ fontSize: 12.5 }}>Refunds</strong>
                                {expandedDetail.returns.map((r) => <div key={r.id}>{money(r.refund_amount)} ({r.quantity} qty)</div>)}
                              </div>
                            )}
                            {expandedDetail.status === 'cancelled' && (
                              <div>
                                <strong style={{ fontSize: 12.5, color: 'var(--danger-dark)' }}>Cancelled</strong>
                                <div>By: {expandedDetail.cancelled_by || '-'}</div>
                                <div>At: {expandedDetail.cancelled_at || '-'}</div>
                                <div>Reason: {expandedDetail.cancel_reason || '-'}</div>
                              </div>
                            )}
                          </div>

                          <div className="row" style={{ gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                            {expandedDetail.status !== 'cancelled' && !payEdit && (
                              <button type="button" style={btn} onClick={() => openPayEdit(expandedDetail)}>Change payment</button>
                            )}
                            {expandedDetail.status !== 'cancelled' && (
                              <button type="button" style={btn} onClick={() => editItems(expandedDetail)}>Edit items</button>
                            )}
                            <button type="button" style={{ ...btn, color: '#d63d5b', borderColor: '#f3c4cf' }} disabled={busy} onClick={() => deleteBill(expandedDetail)}>Delete</button>
                          </div>

                          {payEdit && (
                            <div style={{ marginTop: 10, padding: 12, borderRadius: 10, background: '#fff', border: '1px solid #ece6f2', maxWidth: 520 }}>
                              <div className="row" style={{ gap: 8, flexWrap: 'wrap' }}>
                                {MODES.map((m) => (
                                  <button key={m} type="button" onClick={() => setPayEdit((p) => ({ ...p, isSplit: false, mode: m }))}
                                    style={{ ...btn, textTransform: 'uppercase', background: !payEdit.isSplit && payEdit.mode === m ? '#5b3fd9' : '#fff', color: !payEdit.isSplit && payEdit.mode === m ? '#fff' : '#231a33' }}>{m}</button>
                                ))}
                                <button type="button" onClick={() => setPayEdit((p) => ({ ...p, isSplit: true }))}
                                  style={{ ...btn, background: payEdit.isSplit ? '#5b3fd9' : '#fff', color: payEdit.isSplit ? '#fff' : '#231a33' }}>Split</button>
                              </div>
                              {payEdit.isSplit && (
                                <div className="row" style={{ gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                                  {MODES.map((m) => (
                                    <label key={m} style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase' }}>{m}
                                      <input type="number" min="0" inputMode="decimal" value={payEdit.split[m]} style={{ width: 110, display: 'block' }}
                                        onChange={(e) => setPayEdit((p) => ({ ...p, split: { ...p.split, [m]: e.target.value } }))} />
                                    </label>
                                  ))}
                                  <span style={{ fontSize: 12, alignSelf: 'flex-end', color: 'var(--chocolate)' }}>Must add up to {money(expandedDetail.total_amount)}</span>
                                </div>
                              )}
                              <div className="row" style={{ gap: 8, marginTop: 10 }}>
                                <button type="button" style={btn} onClick={() => setPayEdit(null)}>Cancel</button>
                                <button type="button" style={{ ...btn, background: '#5b3fd9', color: '#fff', borderColor: '#5b3fd9' }} disabled={busy} onClick={() => savePayment(expandedDetail)}>Save payment</button>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {bills.length === 0 && <p>No bills on this date.</p>}
      </div>
    </div>
  );
}
